/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {Formik} from 'formik'
import useUtils from './useUtils'
import {useLocation, useNavigate} from 'react-router-dom'
import {FaTimes} from 'react-icons/fa'
import {useDispatch} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'
import AssignConfirmation from '../../modules/alert/AssignConfirmation'

const AddSubscription = () => {
  const dispatch = useDispatch()
  dispatch(setTitle('Subscription'))
  const location = useLocation()
  const [isOpen, setIsOpen] = useState(false)
  const [benefits, setBenefits] = useState(null)
  const locationState = location?.state?.values || null
  const navigate = useNavigate()
  const {handleEdit, fetchBenefits} = useUtils()
  const [line, setLine] = useState('')

  // Redirect if no subscription data (can't add subscriptions from frontend)
  useEffect(() => {
    if (!locationState) {
      navigate('/subscriptionlist')
    }
  }, [locationState, navigate])

  const initialValues = locationState
    ? {
        id: locationState?.id,
        name: locationState?.name,
        detail: locationState?.detail || '',
        benefitIds:
          locationState?.subscriptionBenefits
            ?.map((val) => (val.benefit ? val.benefit.id : null))
            .filter((id) => id !== null) || [],
      }
    : {
        detail: '',
        benefitIds: [],
      }

  const validationSchema = Yup.object().shape({
    detail: Yup.string().required('Please enter details'),
    benefitIds: Yup.array()
      .min(1, 'At least one benefit must be selected')
      .required('Please select at least one benefit'),
  })

  const handleSubmit = (values) => {
    const data = {
      detail: values.detail,
      benefitIds: values?.benefitIds,
    }
    handleEdit(data, values.id)
  }

  const getBenefits = async () => {
    try {
      const data = await fetchBenefits()
      setBenefits(data?.records)
    } catch (error) {
      console.error('Error fetching settings:', error.message)
    }
  }

  useEffect(() => {
    getBenefits()
  }, [])

  return (
    <>
      <div className='card card-custom'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({values, touched, errors, handleSubmit, setFieldValue}) => (
            <form className='form' onSubmit={handleSubmit}>
              <div className='card-body'>
                <div className='tab-content pt-3'>
                  {/* end::Body */}
                  <div className='row align-items-start flex-wrap mb-5'>
                    <div className='col-12'>
                      <label className='col-form-label fw-bold fs-6 mb-2'>Subscription Name</label>
                      <div
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        style={{backgroundColor: '#f5f8fa'}}
                      >
                        {values.name || 'N/A'}
                      </div>
                    </div>
                  </div>

                  <div className='fs-4 mt-6 fw-bold'>Select benefits</div>
                  {touched.benefitIds && errors.benefitIds && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert' className='text-danger'>
                        {errors.benefitIds}
                      </span>
                    </div>
                  )}
                  <div className='row align-items-start flex-wrap mt-5 ms-1'>
                    {benefits?.map((benefit) => (
                      <div className='col-3' key={benefit.id}>
                        <label className='col-form-label fw-bold fs-6 me-5 text-nowrap'>
                          {benefit.name}
                        </label>
                        <label className='form-check form-check-custom form-check-solid form-switch mb-3'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            checked={values?.benefitIds?.includes(benefit.id)}
                            onChange={() => {
                              const updatedBenefits = values.benefitIds?.includes(benefit.id)
                                ? values.benefitIds.filter((id) => id !== benefit.id)
                                : [...values.benefitIds, benefit.id]
                              setFieldValue('benefitIds', updatedBenefits)
                            }}
                          />
                          {/* <span className='ms-2 text-nowrap'>{benefit.name}</span> */}
                        </label>
                      </div>
                    ))}
                  </div>

                  <div>
                    <div className='mt-5'>
                      <label className='col-form-label required fw-bold fs-6'>
                        Subscription Details
                      </label>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder='Subscription Details'
                        value={line}
                        onChange={(e) => setLine(e.target.value)}
                      />
                      {touched.detail && errors.detail && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {errors.detail}
                          </span>
                        </div>
                      )}
                    </div>
                    <button
                      type='button'
                      className='btn btn-primary mt-4 me-2 fs-7'
                      onClick={() => {
                        setFieldValue(
                          'detail',
                          values.detail && values.detail.length > 0
                            ? values.detail + '\n' + line
                            : line
                        )
                        setLine('')
                      }}
                    >
                      Add
                    </button>

                    <div className='d-flex  align-items-center flex-wrap gap-5 mt-5 '>
                      {values.detail &&
                        values.detail.length > 0 &&
                        values.detail.split('\n').map((val, index) => (
                          <div
                            key={index}
                            className='d-flex gap-8 align-items-center bg-light-primary px-8 py-3 rounded-4 '
                            style={{cursor: 'pointer'}}
                          >
                            <a href='#' className='text-primary fw-semibold fs-6 me-3'>
                              {val}{' '}
                            </a>
                            <div className='rounded-3 p-1'>
                              <FaTimes
                                style={{
                                  color: 'black',
                                  cursor: 'pointer',
                                  fontSize: '18px',
                                }}
                                onClick={() =>
                                  setFieldValue(
                                    'detail',
                                    values.detail
                                      .split('\n')
                                      .filter((_, i) => i !== index)
                                      .join('\n')
                                  )
                                }
                              />
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
              <div>{/* end::Body */}</div>
              {/* end::Body */}
              <div className='d-flex align-items-center  justify-content-end my-5'>
                <button
                  type='button'
                  className='btn btn-danger ms-2 mt-2 me-2'
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button
                  type='button'
                  onClick={() => {
                    setIsOpen(true) // Open the confirmation modal
                  }}
                  className='btn btn-primary ms-2 mt-2 me-2'
                >
                  Update
                </button>
              </div>
            </form>
          )}
        </Formik>
        {/* end::Form */}
      </div>
      <AssignConfirmation
        isVisible={isOpen}
        message='Are you sure you want to update this Subscription?'
        onConfirm={() => {
          setIsOpen(false)
          setTimeout(() => {
            document.querySelector('form')?.requestSubmit() // Triggers form submission
          }, 0)
        }}
        onCancel={() => setIsOpen(false)}
      />
    </>
  )
}

export default AddSubscription
